import { connectedLabFragment } from 'apollo/fragments';
import {
    dentistFragment,
    linkedOrganizationFragment,
    nameFragment,
    technicianFragment,
    userListFragment,
} from 'apollo/fragments/user';
import { gql } from 'graphql.macro';

export const addDentistTemplate = gql`
    mutation addDentist(
        $name: NameInput!
        $email: String!
        $role: String!
        $organization: MongoDbObjectId!
        $defaultClinic: MongoDbObjectId
        $title: String
        $authMethod: AuthMethod
        $syncid: String
        $personalIdentityNumber: String
        $active: Boolean
        $note: String
        $enableUserSync: Boolean
    ) {
        addDentist(
            name: $name
            email: $email
            role: $role
            organization: $organization
            defaultClinic: $defaultClinic
            title: $title
            authMethod: $authMethod
            syncid: $syncid
            personalIdentityNumber: $personalIdentityNumber
            active: $active
            note: $note
            enableUserSync: $enableUserSync
        ) {
            ...dentistFields
        }
    }
    ${dentistFragment}
`;

export const modifyDentistTemplate = gql`
    mutation modifyDentist($dentist: DentistInput!) {
        modifyDentist(dentist: $dentist) {
            ...dentistFields
        }
    }
    ${dentistFragment}
`;

export const modifyUserTemplate = gql`
    mutation modifyUser($user: UserModifyInput!) {
        modifyUser(user: $user) {
            ...userListFields
        }
    }
    ${userListFragment}
`;

export const addTechnicianTemplate = gql`
    mutation addTechnician(
        $name: NameInput!
        $email: String!
        $role: String!
        $organization: MongoDbObjectId!
        $isShared: Boolean
        $authMethod: AuthMethod
        $syncid: String
        $personalIdentityNumber: String
        $enableUserSync: Boolean
    ) {
        addTechnician(
            name: $name
            email: $email
            role: $role
            organization: $organization
            isShared: $isShared
            authMethod: $authMethod
            syncid: $syncid
            personalIdentityNumber: $personalIdentityNumber
            enableUserSync: $enableUserSync
        ) {
            ...technicianFields
        }
    }
    ${technicianFragment}
`;

export const modifyTechnicianTemplate = gql`
    mutation modifyTechnician($technician: TechnicianInput!) {
        modifyTechnician(technician: $technician) {
            ...technicianFields
            salesforceUser {
                id
                name
                email
            }
        }
    }
    ${technicianFragment}
`;

export const linkUserToOrganizationTemplate = gql`
    mutation linkUserToOrganization($userId: MongoDbObjectId!, $linkDetails: LinkUserInput!) {
        linkUserToOrganization(userId: $userId, linkDetails: $linkDetails) {
            _id
            fullName
            name {
                ...nameFields
            }
            email
            authMethod
            syncid
            title
            phone
            comments
            role
            organization {
                _id
                name
                type
                isWhiteLabeled
                connectedLabs {
                    ...connectedLabFields
                }
            }
            active
            systemSetting {
                clinic {
                    _id
                    name
                }
            }
            local
            linkedOrganizations {
                ...linkedOrganizationFields
            }
            whiteLabelAccess
        }
    }

    ${nameFragment}
    ${linkedOrganizationFragment}
    ${connectedLabFragment}
`;

export const generateEmailOtpForUserTemplate = gql`
    mutation generateEmailOtpForUser($userId: MongoDbObjectId!) {
        generateEmailOtpForUser(userId: $userId) {
            email
            code
            expiresAt
        }
    }
`;
